var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticClass:"body"},[_c('ToolBar',{attrs:{"links":_vm.links,"moduleName":_vm.moduleName}}),_c('div',{staticStyle:{"padding":"20px"}},[_c('sequential-entrance',{attrs:{"fromRight":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }